import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { refreshSession, logout } from '../redux/reducers';
import { readSessionFlag } from './authCookies';

// Refresh the access token when it has 23 hours or less of life left.
const REFRESH_THRESHOLD_SECONDS = 82800;

const SessionManager = ({ children }) => {
  const location = useLocation();
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  // WARNING: if you change any of this, update SessionManager.jsx in web too.
  //
  // The access/refresh JWTs are httpOnly and unreadable here. We rely on the
  // readable session flag cookie ({ account_id, exp }) set alongside them by the
  // API to detect login state and decide when to proactively refresh.
  useEffect(() => {
    const currentTime = Math.round(Date.now() / 1000);
    const flag = readSessionFlag();
    const reduxAccountId =
      auth && auth.user && auth.user.id != null ? parseInt(auth.user.id) : null;

    const signedInUserNotSyncedWithSession = Boolean(
      flag && reduxAccountId !== null && flag.account_id !== reduxAccountId
    );
    const signedInUserHasNoSession = Boolean(!flag && reduxAccountId !== null);
    // Use a falsy check, not strict `=== null`: a redux-persist rehydration can
    // leave auth.user as undefined rather than the reducer's null default, and
    // that must still count as "not signed in" or the refresh never fires.
    const userNotSignedInButSessionPresent = Boolean(flag && auth && !auth.user);

    // Refresh if the access token is missing an expiry or is within the threshold.
    const shouldRefreshAccessToken = Boolean(
      flag && (!flag.exp || flag.exp - currentTime <= REFRESH_THRESHOLD_SECONDS)
    );

    if (signedInUserHasNoSession) {
      console.log('Signed in user has no session - logging out');
      dispatch(logout(false, true)); // true = redirect back to the current page after subsequent login
    } else if (
      signedInUserNotSyncedWithSession ||
      userNotSignedInButSessionPresent ||
      shouldRefreshAccessToken
    ) {
      dispatch(refreshSession());
    }
  }, [location]);

  return <>{children}</>;
};

export default SessionManager;
